module.exports = __webpack_public_path__ + "static/media/banner_login.2505ac60.png";